module.exports = __webpack_public_path__ + "static/img/22.f1c2f54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/22.png
// module id = gVKS
// module chunks = 0